import { FC } from 'react';

import { SvgIconProps } from 'types/styles';
import { SvgIcon } from 'ui/SvgIcon';

export const CrossIcon: FC<SvgIconProps> = (props) => (
  <SvgIcon
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="11"
    height="12"
    viewBox="0 0 11 12"
    fill="none"
  >
    <path
      d="M10.8536 10.773L10.4999 11.1266C10.3047 11.3218 9.98815 11.3218 9.79285 11.1266L5.72702 7.06068L1.66112 11.1265C1.4659 11.3218 1.14931 11.3218 0.954045 11.1265L0.600487 10.773C0.405225 10.5777 0.405225 10.2612 0.600487 10.0659L4.66637 6.00003L0.600487 1.93413C0.405225 1.73891 0.405225 1.42232 0.600487 1.22706L0.954037 0.873505C1.1493 0.678242 1.4659 0.678242 1.66112 0.873505L5.72702 4.93938L9.79285 0.873498C9.98815 0.678235 10.3047 0.678235 10.4999 0.873498L10.8536 1.22705C11.0488 1.42231 11.0488 1.73891 10.8536 1.93413L6.78767 6.00003L10.8536 10.0659C11.0488 10.2612 11.0488 10.5777 10.8536 10.773Z"
      fill="currentColor"
    />
  </SvgIcon>
);
